import { QueryDtoOf } from '@40seas/entities/common';
import { Transaction } from './transaction.entity';

export class QueryTransactionDto extends QueryDtoOf(Transaction) {}
